// Build configuration and metadata
export const buildConfig = {
  // This will be replaced at build time by Vite
  buildTime: import.meta.env.VITE_BUILD_TIME || new Date().toISOString(),
  // Git commit hash (if available)
  commitHash: import.meta.env.VITE_COMMIT_HASH || 'development',
  // Build environment
  environment: import.meta.env.MODE || 'development'
}